"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.willBePendingGroup = exports.canResolvePendingGroups = exports.canCreateGroup = exports.isUserLoggedIn = exports.isUserSiteAdmin = void 0;
var types_1 = require("../../types");
function isUserSiteAdmin(user) {
    return user && user.role === 'Admin';
}
exports.isUserSiteAdmin = isUserSiteAdmin;
function isUserLoggedIn(user) {
    return user && user.loggedIn;
}
exports.isUserLoggedIn = isUserLoggedIn;
function canCreateGroup(user, createGroupPolicy) {
    var isLoggedIn = isUserLoggedIn(user);
    if (!isLoggedIn) {
        return false;
    }
    var isAdmin = isUserSiteAdmin(user);
    if (isAdmin) {
        return true;
    }
    var isOnlyAdminCanCreateGroups = createGroupPolicy === types_1.ApiTypes.v1.CreateGroupsPolicy.ONLY_ME;
    return !isOnlyAdminCanCreateGroups;
}
exports.canCreateGroup = canCreateGroup;
function canResolvePendingGroups(user) {
    return isUserLoggedIn(user) && isUserSiteAdmin(user);
}
exports.canResolvePendingGroups = canResolvePendingGroups;
function willBePendingGroup(user, createGroupPolicy) {
    if (isUserSiteAdmin(user)) {
        return false;
    }
    return createGroupPolicy !== types_1.ApiTypes.v1.CreateGroupsPolicy.MEMBERS;
}
exports.willBePendingGroup = willBePendingGroup;
//# sourceMappingURL=permissions.js.map